export default __webpack_public_path__ + "static/media/Mary.795126dd.jpeg";